import { Flex, Typography } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import sendArrow from "@iso/assets/images/sendArrow.svg";

const footerButtonStyle = {
    border: "1px solid gray",
    borderRadius: "50%",
    marginRight: "10px",
    color: "#475569"
};

const attachmentIconStyle = {
    position: "absolute",
    top: "20px",
    right: "20px",
    fontSize: "20px"
};

const sendButtonStyle = {
    background: "#6486ee",
    borderRadius: "20px",
    color: "#ffffff",
    padding: "5px",
};

export default function AIAgentFooter({ components, data, open, setOpen, loading, handleLoad, attachments }) {
    const { SendButton, LoadingButton, SpeechButton } = components;
    return (
        <Flex justify="end" align="center">
            <Flex align="center">
                {/* {!open && <PaperClipOutlined onClick={() => setOpen(open => !open)} style={{...attachmentIconStyle, color: attachments?.length > 0 && "blue"}} />} */}
                <Typography.Text style={{marginRight: "10px"}}>{data?.length} / 5000</Typography.Text>
                <SpeechButton disabled={loading} style={footerButtonStyle} />
                {loading ? (
                    <LoadingButton type="default" onClick={handleLoad}/>
                ) : (
                    <SendButton
                        type="primary"
                        disabled={!data}
                        style={sendButtonStyle}
                        icon={<img src={sendArrow}/>}
                        iconPosition="end"
                    >
                        Send
                    </SendButton>
                )}
            </Flex>
        </Flex>
    );
}